var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmbedContent = function SvgEmbedContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667,
    width: 39,
    height: 40,
    rx: 8,
    fill: "#966BDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.643 9.992H12.67h14.972Zm2.264 5.437h-19.5v12.233c0 1.287 1.017 2.33 2.272 2.33h14.956c1.255 0 2.272-1.043 2.272-2.33V15.429Zm-11.135 4.042a.837.837 0 0 0-1.205 0l-2.083 2.136-.03.033a.89.89 0 0 0 .03 1.203l2.083 2.136.032.03c.334.31.85.3 1.173-.03l.03-.033a.89.89 0 0 0-.03-1.203l-1.48-1.518 1.48-1.518.03-.033a.89.89 0 0 0-.03-1.203Zm4.165 0a.837.837 0 0 0-1.205 0 .89.89 0 0 0-.03 1.203l.03.033 1.48 1.518-1.48 1.518a.89.89 0 0 0-.03 1.203l.03.033c.322.33.838.34 1.173.03l.032-.03 2.082-2.136a.89.89 0 0 0 .03-1.203l-.03-.033-2.082-2.136Z",
    fill: "url(#embed-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.907 15.429h-19.5v-3.107c0-1.287 1.017-2.33 2.272-2.33h14.956c1.255 0 2.272 1.043 2.272 2.33v3.107Zm-16.85-1.36c.628 0 1.137-.52 1.137-1.164 0-.644-.509-1.165-1.136-1.165-.628 0-1.136.521-1.136 1.165 0 .643.508 1.165 1.136 1.165Zm4.166-1.164c0 .643-.509 1.165-1.136 1.165-.628 0-1.136-.522-1.136-1.165 0-.644.508-1.165 1.136-1.165.627 0 1.136.521 1.136 1.165Zm1.893 1.165c.627 0 1.136-.522 1.136-1.165 0-.644-.509-1.165-1.136-1.165-.628 0-1.136.521-1.136 1.165 0 .643.508 1.165 1.136 1.165Z",
    fill: "url(#embed-content_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "embed-content_svg__a",
    x1: 20.13,
    y1: 14.22,
    x2: 20.581,
    y2: 36.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "embed-content_svg__b",
    x1: 20.157,
    y1: 9.992,
    x2: 20.157,
    y2: 15.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgEmbedContent;